/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Each slice's percentage of the total is computed automatically and shown in the tooltip.`)
};

const es_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El porcentaje del total de cada porción se calcula automáticamente y se muestra en la información emergente.`)
};

const de_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Der Prozentanteil jedes Segments am Gesamtwert wird automatisch berechnet und im Tooltip angezeigt.`)
};

const nl_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Het percentage van elk segment ten opzichte van het totaal wordt automatisch berekend en getoond in de tooltip.`)
};

const fr_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le pourcentage de chaque secteur par rapport au total est calculé automatiquement et affiché dans l'infobulle.`)
};

const it_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. La percentuale sul totale di ciascuna fetta viene calcolata automaticamente e mostrata nel tooltip.`)
};

const pt_br2_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O percentual de cada fatia em relação ao total é calculado automaticamente e exibido no tooltip.`)
};

const pt_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A percentagem de cada fatia no total é calculada automaticamente e mostrada na dica.`)
};

const ja_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。各スライスの全体に対する割合は自動的に計算され、ツールチップに表示されます。`)
};

const zh_pie_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。每个扇形占总数的百分比会自动计算，并显示在提示框中。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_faq_a2", locale)
	if (locale === "en") return en_pie_faq_a2(inputs)
	if (locale === "es") return es_pie_faq_a2(inputs)
	if (locale === "de") return de_pie_faq_a2(inputs)
	if (locale === "nl") return nl_pie_faq_a2(inputs)
	if (locale === "fr") return fr_pie_faq_a2(inputs)
	if (locale === "it") return it_pie_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_pie_faq_a2(inputs)
	if (locale === "pt") return pt_pie_faq_a2(inputs)
	if (locale === "ja") return ja_pie_faq_a2(inputs)
	return zh_pie_faq_a2(inputs)
};